const ALLOW_GMAPS = false; // TODO: Wert aus dem Cookie-Banner beziehen.

const renderGmaps = async (gmapElements) => {
  gmapElements.forEach((gmap) => {
    const acceptanceEl = gmap.querySelector('.gmaps-acceptance');
    const iframe = document.createElement('iframe');
    iframe.src = gmap.dataset.gmapSrc;
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute('width', gmap.dataset.gmapWidth || 600);
    iframe.setAttribute('height', gmap.dataset.gmapHeight || 450);
    iframe.setAttribute('style', 'border:0;');
    gmap.appendChild(iframe);
    if (acceptanceEl) acceptanceEl.remove();
  });
};

const displayGmapsAcceptanceBtn = (gmapElements) => {
  gmapElements.forEach((gmap) => {
    const acceptanceEl = document.createElement('div');
    const acceptanceBtn = document.createElement('button');
    acceptanceEl.classList.add('gmaps-acceptance');
    acceptanceEl.innerHTML =
      'Wir nutzen für unsere Karte den Dienst von Google Maps. Eine Einbindung und Datenweitergabe an Google erfolgt erst, nachdem Sie dem zugestimmt haben. Weitere Informationen finden Sie in den Informationen zum <a href="https://www.museumpab.de/datenschutz/">Datenschutz</a>.';
    acceptanceBtn.textContent = 'Google maps erlauben und ansehen';
    acceptanceBtn.classList.add('btn-primary');
    acceptanceEl.appendChild(acceptanceBtn);
    gmap.appendChild(acceptanceEl);

    acceptanceBtn.onclick = async () => {
      // TODO: Cookie setzen, damit Google Maps auf dieser Session erlaubt bleibt.
      await renderGmaps(gmapElements);
      acceptanceEl.remove();
    };
  });
};

export function initGmaps() {
  const gmapElements = document.querySelectorAll('[data-gmap]');
  if (!gmapElements.length) return;

  if (!ALLOW_GMAPS) {
    displayGmapsAcceptanceBtn(gmapElements);
  } else {
    renderGmaps(gmapElements);
  }
}
